import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/Button'

function LoadingButton(props) {
  const { style, variant, btnText, className, onClick, disabled, size } = props
  const [clicked, setclicked] = useState(false)
  return (
    <Button
      size={size}
      style={{ minWidth: '4rem', ...style }}
      variant={variant}
      className={className}
      onClick={async (e) => {
        setclicked(true)
        await onClick(e)
        setclicked(false)
      }}
      disabled={clicked || disabled}
    >
      {clicked ? (
        <span className="spinner-border spinner-border-sm" />
      ) : (
        btnText
      )}
    </Button>
  )
}

LoadingButton.propTypes = {
  style: PropTypes.shape(),
  variant: PropTypes.string,
  btnText: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.string,
}

LoadingButton.defaultProps = {
  style: {},
  variant: 'outline-dai',
  btnText: '確 定',
  className: '',
  onClick: () => {},
  disabled: false,
  size: 'md',
}

export default LoadingButton
